import { h, FunctionComponent } from 'preact'
import FieldWrapper from '../components/FieldWrapper'
import classes from './index.scss'
import { htmlEncodeByRegExp } from 'scripts/utils'
import { EndingField as EndingFieldType, TriggerEvent } from 'scripts/type'
import { useContext } from 'preact/compat'
import { WIDGET_AUTO_CLOSE_DURATION } from 'scripts/constants'
import { postMessage } from 'scripts/utils'
import BaseContext from 'contexts/base-context'
import { useEffect } from 'preact/hooks'
import { FieldCommonProps } from '../type'

const EndingField: FunctionComponent<FieldCommonProps> = (props) => {
  const field = props.field as EndingFieldType
  const { content, label, description, autoCloseEnabled = true, autoCloseDuration, image } = field
  const { urlToken } = useContext(BaseContext)
  const message = htmlEncodeByRegExp(label || content || '感谢您的反馈')
  const desc = htmlEncodeByRegExp(description || '')

  useEffect(() => {
    if (autoCloseEnabled) {
      setTimeout(() => {
        postMessage({ name: TriggerEvent.Close, data: { campaignToken: urlToken } })
      }, autoCloseDuration ?? WIDGET_AUTO_CLOSE_DURATION)
    }
  }, [])

  return (
    <FieldWrapper {...props} field={field}>
      <div className={classes.endingWrapper}>
        {!image && (
          <div className={classes.endingImgWrapper}>
            <img width={64} height={64} src="https://static.howxm.com/celebration.gif" alt="howxm-ending" />
          </div>
        )}
        <div className={classes.endingContent} dangerouslySetInnerHTML={{ __html: message }} />
        {!!desc && <div className={classes.endingDesc} dangerouslySetInnerHTML={{ __html: desc }} />}
      </div>
    </FieldWrapper>
  )
}

export default EndingField
